import { registerChildWindow } from 'components/CallScribe/popupChannel';
import { callPopupFeatures, fitCallPopupToScreen } from 'components/CallScribe/popupWindowFeatures';
import {
  newPopupTicket,
  registerPopupTicket,
  withPopupTicket,
} from 'components/CallScribe/popupTicket';

const WINDOW_NAME_PREFIX = 'mspp-callscribe-window';

export interface IOpenCallScribeWindowParams {
  psaId: number;
  ticketId: string;
  screen?: string;
}

export const buildCallScribeWindowUrl = ({
  psaId,
  ticketId,
  screen,
}: IOpenCallScribeWindowParams): string => {
  const url = new URL(`/pod/autotask/${psaId}`, window.location.origin);
  url.searchParams.set('ticketId', ticketId);
  if (screen) {
    url.searchParams.set('screen', screen);
  }
  url.searchParams.set('callscribe', 'window');
  return url.toString();
};

export const callScribeWindowName = ({
  psaId,
  ticketId,
  screen,
}: IOpenCallScribeWindowParams): string =>
  (screen
    ? `${WINDOW_NAME_PREFIX}-${psaId}-${screen}-${ticketId}`
    : `${WINDOW_NAME_PREFIX}-${psaId}-${ticketId}`);

export const openCallScribeWindow = (
  params: IOpenCallScribeWindowParams,
): Window | null => {
  const ticket = newPopupTicket();
  const url = withPopupTicket(buildCallScribeWindowUrl(params), ticket);
  const name = callScribeWindowName(params);

  const opened = window.open('', name, callPopupFeatures());
  if (!opened) {
    const direct = window.open(url, name);
    registerChildWindow(direct);
    if (direct) void registerPopupTicket(ticket);
    return direct;
  }

  let fresh = true;
  try {
    fresh = opened.location.href === 'about:blank';
  } catch {
    fresh = true;
  }

  let handle: Window | null = opened;
  if (fresh) {
    try {
      opened.location.replace(url);
    } catch {
      handle = window.open(url, name);
    }
    void registerPopupTicket(ticket);
  }

  if (!fresh) fitCallPopupToScreen(handle);
  registerChildWindow(handle);
  try {
    handle?.focus();
  } catch { }
  return handle;
};

export const isCallScribeWindowView = (): boolean => {
  try {
    return new URLSearchParams(window.location.search).get('callscribe') === 'window';
  } catch {
    return false;
  }
};
